import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Apply from "@/pages/Apply";
import Login from "@/pages/Login";
import MemberArea from "@/pages/MemberArea";
import MyPlans from "@/pages/MyPlans";
import PlanDetail from "@/pages/PlanDetail";
import Profile from "@/pages/Profile";
import SupportPage from "@/pages/SupportPage";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import StatusScreen from "@/pages/StatusScreen";
import ClubEtiquette from "@/pages/legal/ClubEtiquette";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFCFA]">
      <div className="font-serif text-3xl text-[#48020C] tracking-wide animate-pulse">The Social Club</div>
    </div>
  );
}

function Protected({ children, admin = false }) {
  const { user, checking } = useAuth();
  if (checking || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/area" replace />;
  if (!admin && user.role !== "admin" && user.status !== "approved") return <StatusScreen />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/candidatura" element={<Apply />} />
            <Route path="/login" element={<Login />} />
            <Route path="/recuperar-password" element={<ResetPassword />} />
            <Route path="/club-etiquette" element={<ClubEtiquette />} />
            <Route path="/termos" element={<Terms />} />
            <Route path="/privacidade" element={<Privacy />} />
            <Route path="/area" element={<Protected><MemberArea /></Protected>} />
            <Route path="/area/os-meus-planos" element={<Protected><MyPlans /></Protected>} />
            <Route path="/area/plano/:id" element={<Protected><PlanDetail /></Protected>} />
            <Route path="/area/perfil" element={<Protected><Profile /></Protected>} />
            <Route path="/area/suporte" element={<Protected><SupportPage /></Protected>} />
            <Route path="/admin" element={<Protected admin><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
